import PropTypes from 'prop-types';
import React from 'react';
import cn from 'classname';

import Select from './select';

const propTypes = {
	meta: PropTypes.object,
	input: PropTypes.object,
	loadOptions: PropTypes.func,
	placeholder: PropTypes.string,
	showLabel: PropTypes.bool,
	children: PropTypes.node
};

const defaultProps = {
	showLabel: true
};

const Field = props => {
	const { touched, error } = props.meta;
	return (
		<div className='form-element-select-improve'>
			<div className={cn(
				'form-element-field',
				props.showLabel && 'form-element-field--show-label'
			)}>
				<div className="form-element-field__label">
					{ props.placeholder }
				</div>
				{props.children}
				<Select {...props} {...props.input} />
				{touched && error && <span className="form-element-error">{error}</span>}
			</div>
		</div>
	);
};

Field.propTypes = propTypes;
Field.defaultProps = defaultProps;

export default Field;



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/shared/form-elements/select-countries/field.js